export const apiField = 'numberical_coefficient';
export default {
  type: 'Text',
  label: 'NumericalCoefficient',
  missing: undefined,
  apiField,
  tooltip: undefined,
};

